import {AudioDirector} from '../../components/audio-director.js';
import {GameFlowController} from '../../components/game-flow-controller.js';
import {MissionManager} from '../../components/mission-manager.js';
import {Statistics} from '../../components/statistics.js';
import {StoreManager} from '../../components/store-manager.js';
import {Sounds} from '../../enums/Sounds.js';
import {TransactionalNames} from '../../enums/TransactionalNames.js';

export function buySkipMission(missionID: number) {
    const storeManager = StoreManager.instance;

    const coinCost = storeManager.missionSkipCost;

    const currentCoins = Statistics.instance.getTransactional(TransactionalNames.CoinCount);

    if (currentCoins < coinCost) {
        GameFlowController.instance.goToCoinStore();
    } else {
        AudioDirector.instance.playOneShot(Sounds.successfulPurchase, true);

        Statistics.instance.addAnonymousPurchaseTransaction(
            TransactionalNames.CoinCount,
            -coinCost
        );

        const missionManager = MissionManager.instance;
        missionManager.setMissionComplete(missionID);

        GameFlowController.instance.popMenu(() => {
            //missionReqScreen.UpdateMissionsNow();
        });
    }
}
